export const GoodsGroupByGoodPluginSettings: IPluginSettings = {
    name: 'Группа товаров',
    mnemocode: 'goods_groupByGood_plugin',
    permission: 'Goods',
    columns: [
    {
        order: 2,
        propertyName: 'name',
        propertyType: 'string',
        displayName: 'Наименование',
        visibility: true,
        width: 300
    },
    {
        order: 3,
        propertyName: 'level',
        propertyType: 'number',
        displayName: 'Уровень',
        visibility: false,
        width: 157
    },
    
    ],
}
export default GoodsGroupByGoodPluginSettings